
const from_server = {
    // youtubeUrl: 'https://www.youtube.com/embed/Ch61sWfuTL8', 
    // video: `https://s3-cms.rsv.ru/RSV_imidge_11.mp4`,
    video: `https://s3-cms.rsv.ru/RSV_imidge_6.mp4`,
    // Forum rsv
    // video: `https://s3-cms.rsv.ru/30s_logo_screen_5.mp4`,
    // videoWebm: `https://s3-cms.rsv.ru/still_logos_blue.webm`,
};


export default {
    state: {
        rMainState: {},
    },
    mutations: {
        writeMainState: (state, data) => state.rMainState = data,
    },
    actions: {
        loadRMain: ctx => {
            ctx.commit('writeMainState', from_server);
        },
    },
    getters: {
        rMainState: state => state.rMainState,
    },
};
